<template>
    <div class="hello">
        <div v-for="item,index in barList" :key="index" style="width: 100%;">
            <router-link class="home_box" :to="item.to" :style="barStates == index? 'color: #00B1AE;background-color: #ffffff;':''">
                <img class="home_img" :src="barStates == index? item.img1 : item.img2" alt="">
                {{ item.name }}
            </router-link>
        </div>
    </div>
</template>
<script>
export default {
    name: 'NavigationBar',
    props: ['barStates', 'barList'],
    data() {
        return {
            
        }
    },
    mounted() {
        if(!localStorage.getItem('token')) {
            this.$message.error('请先登录');
            localStorage.clear();
            this.$router.push('/login');
        }
    },
    methods: {}
}
</script>
<style scoped lang="less">
* {
    margin: 0;
    padding: 0;
}
.hello {
    width: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: linear-gradient(193deg, #FCE5EC 0%, #CBF9FC 100%);
    box-shadow: 0px 0px 32px 0px rgba(0,0,0,0.05);
    padding: 30px 0;

    .home_box {
        width: calc(100% - 64px);
        height: 60px;
        padding: 0 32px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        font-family: Source Han Sans CN;
        font-weight: 500;
        font-size: 18px;
        color: #333333;

        .home_img {
            width: 22px;
            object-fit: contain;
            margin-right: 10px;
            margin-top: 2px;
        }
    }
    .home_box:hover {
        background-color: #F5F5F5;
    }
}
</style>